import React from 'react';
import classNames from 'classnames';
import styles from './SkipLinks.module.scss';
import useSkipLinks from './useSkipLinks';

function SkipLinks({ className }) {
  const { skipLinks } = useSkipLinks();
  return (
    <nav className={classNames(styles.skipLinks, className)}>
      <ul>
        {skipLinks.map((link) => (
          <li key={link.title}>
            {/* <a href=#{link.id}>Go to {link.title}</a> */}
            <a href={`#${link.id}`}>{link.title}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
export default SkipLinks;
